import React from 'react';
import { motion } from 'framer-motion';
import { SectionFlourish } from './Ornaments';

export default function Intro() {
  const scrollToRsvp = (e) => {
    e.preventDefault();
    document.getElementById('rsvp')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="details" className="bg-aged-ivory px-6 py-16 md:py-32 relative">
      <motion.div 
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="max-w-4xl mx-auto text-center"
      >
        <SectionFlourish className="w-20 md:w-24 h-6 text-estate-gold mx-auto mb-6 md:mb-8" />
        <h2 className="font-serif text-3xl md:text-6xl text-burgundy mb-6 md:mb-8 leading-tight px-2">
          More Estate Experience. <br className="hidden md:block"/> Less Vendor Expo.
        </h2>
        <p className="font-sans font-light text-sm md:text-xl text-charcoal/80 leading-relaxed md:leading-loose text-balance mb-8 md:mb-12 max-w-3xl mx-auto px-2">
          The Padua Midsummer Affair is designed for couples who want to explore naturally—not walk through rows of sales tables. Tour the estate, enjoy the atmosphere, meet carefully selected professionals, and imagine how your wedding could unfold throughout Padua.
        </p>
        <a 
          href="#rsvp" 
          onClick={scrollToRsvp}
          className="inline-block border border-burgundy text-burgundy font-sans text-[10px] md:text-xs uppercase tracking-widest px-8 md:px-10 py-4 md:py-5 hover:bg-burgundy hover:text-ivory transition-all duration-500"
        >
          Claim Your Complimentary Invitation
        </a>
      </motion.div>
    </section>
  );
}